export default __webpack_public_path__ + "static/media/NJOI-Logo.ce4c6a87.png";